// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateThaiMobileBankingBankCode(selectedPaymentMethod: string, selectedEwallet: string, bankCodeValue: string): ?UserInputValidationError {
  if (
    selectedPaymentMethod === 'ewallet'
    && selectedEwallet === 'mobile-banking'
    && (bankCodeValue === '' || bankCodeValue === null || bankCodeValue === undefined)
  ) {
    return {id: 'empty'};
  }
}
